// AIRUN project site, linked from the AI chat (header logo and AIRUN mentions in
// messages). UTM tags let AIRUN see the traffic coming from the chat.
export const AIRUN_CHAT_URL = (() => {
  const url = new URL('https://airun.bdigital.kg/')
  url.searchParams.set('utm_source', 'banks.kg')
  url.searchParams.set('utm_medium', 'referral')
  url.searchParams.set('utm_campaign', 'ai_chat')
  return url.toString()
})()
